import { render } from "./TemplateManagerComponent.vue?vue&type=template&id=41caa69e"
import script from "./TemplateManagerComponent.vue?vue&type=script&lang=js"
export * from "./TemplateManagerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/components/TemplateManagerComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41caa69e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41caa69e', __exports__)) {
    api.reload('41caa69e', __exports__)
  }
  
  module.hot.accept("./TemplateManagerComponent.vue?vue&type=template&id=41caa69e", () => {
    api.rerender('41caa69e', render)
  })

}


export default __exports__